import axios from 'axios';

const mid = sessionStorage.getItem('mid') || null;
const token = sessionStorage.getItem('token') || null;
const csrfTokenFromMeta = document.querySelector('meta[name="csrf-token"]').content;

export const loadMore = (type, type_id, page, size, csrfToken) => {
    let request = axios.create();
    request.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    request.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken || csrfTokenFromMeta;
    return request.get(`/api/load/${type}/${type_id}/${page}/${size}`);
};

export const getPremiumArticle = (nid) => {
    let request = axios.create();
    request.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    request.defaults.headers.common['X-CSRF-TOKEN'] = csrfTokenFromMeta;
    request.defaults.headers.common['X-SEHSEH-Mid'] = mid;
    request.defaults.headers.common['X-SEHSEH-Token'] = token;
    return request.get('/api/premium-article/' + nid);
};

export const commentGet = (nid, current_id, size) => {
    let uri = `/api/v2/article-comment/get/${nid}/${current_id}/${size}`;
    let commentPostRequest = axios.create();
    commentPostRequest.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    commentPostRequest.defaults.headers.common['X-CSRF-TOKEN'] = csrfTokenFromMeta;
    return commentPostRequest.get(uri);
};

export const commentNumsGet = (nid, current_id) => {
    let uri = `/api/v2/article-comment-nums/get/${nid}/${current_id}`;
    let commentPostRequest = axios.create();
    commentPostRequest.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    commentPostRequest.defaults.headers.common['X-CSRF-TOKEN'] = csrfTokenFromMeta;
    return commentPostRequest.get(uri);
};

export const commentPost = (nid, comment) => {
    let commentPostRequest = axios.create();
    commentPostRequest.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    commentPostRequest.defaults.headers.common['X-CSRF-TOKEN'] = csrfTokenFromMeta;
    commentPostRequest.defaults.headers.common['X-SEHSEH-Mid'] = mid;
    commentPostRequest.defaults.headers.common['X-SEHSEH-Token'] = token;
    return commentPostRequest.post('/api/v1/article-comment/create', {'nid': nid, 'content': comment});
};

const pvRequest = axios.create({
    baseURL: 'https://service-pvapi.storm.mg/pvapi'
});

export const recordPV = function (nid, aid) {
    return pvRequest.post('/record_pv/', {'nid': nid, 'aid': aid});
};
